module.exports = __webpack_public_path__ + "media/your_career_track/high-school-teacher-hover-9aa39a3f.png";